<div class="balance-breakdown" *ngIf="breakdown && breakdown.accounts && breakdown.accounts.length > 1">
    <a class="more-info__header" (class)="{'more-info__header--clicked': breakdownVisible}" role="button"
        (click)="showBreakdown()" style="border: none; min-height: 0; margin-bottom: 0; padding-bottom: 0;">
        {{config.viewRentBreakdownText}}
    </a>
    <div class="more-info__content" style="padding: 0; margin: 0; display: block;" *ngIf="breakdownVisible">
        <div class="breakdown">
            <div class="breakdown__section" style="margin-bottom: 0;">
                <div class="breakdown__item" *ngFor="let account of breakdown.accounts"
                    style="padding: 5px 10px 5px 10px; background: white;">
                    <span class="breakdown__item-name" style="color: #63656a;">{{account.type}}</span>
                    <span class="breakdown__item-cost" style="color: #63656a;">{{account.balanceText}}</span>
                </div>
            </div>
        </div>
    </div>
</div>